import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpInterceptor, HttpRequest, HttpEvent, HttpHandler } from '@angular/common/http';
import { UrlBuilderService } from '../../common/services/url-builder.service';
import { OidcAuthService } from '@auth/services/oidc-auth.service';

@Injectable()
export class IdServerInterceptor implements HttpInterceptor {
  constructor(private urlBuilderService: UrlBuilderService, private oidcAuthService: OidcAuthService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const idServerUrl = this.urlBuilderService.getIdentityServerUrl('');
    if (request.url.startsWith(idServerUrl)) {
      const productInfo = this.oidcAuthService.getProductInfo();
      request = request.clone({
        params: request.params
          .set('productId', productInfo.product)
          .set('platformId', productInfo.platform)
          .set('brandId', productInfo.brand)
      });
    }
    
    return next.handle(request);
  }
}
